import { atom } from 'jotai'

/**
 * 画面上部にドッキング表示する車両行の rowKey。同時に 1 台のみ。
 * 車両スケジュール比較のための一時的な表示なので永続化しない (リロードで解除)。
 */
export const pinnedRowKeyAtom = atom<string | null>(null)

pinnedRowKeyAtom.debugLabel = 'pinnedRowKeyAtom'

/**
 * ドッキング表示中のピン止め行の実高さ(px)。ピン止めなしは 0。
 * ドッキング行は本体のスクロール領域に重なるため、本体側のヘッダー下にこの高さの余白を作り、
 * 先頭の車両行がドッキング行の裏に潜り込まないようにする。
 */
export const pinnedRowHeightAtom = atom(0)

pinnedRowHeightAtom.debugLabel = 'pinnedRowHeightAtom'
